import type { FunctionComponent } from 'react';

import { useGameConfig } from '../../../../config/GameConfigProvider';
import { useCoreDispatch } from '../../../../store/CoreStore';
import { headerActions } from '../../../../store/slices/header/slice';
import { QuickGuidePlain } from '../../../quickGuide/QuickGuidePlain';

export const NavQuickGuideConnected: FunctionComponent = () => {
  const { quickGuideContent } = useGameConfig();
  const dispatch = useCoreDispatch();

  const handleClose = (): void => {
    dispatch(headerActions.setNavRoute([]));
  };

  return (
    quickGuideContent && <QuickGuidePlain isOpen={true} listItems={quickGuideContent} onPlayAction={handleClose} />
  );
};
